import { createAction } from 'redux-act';

export const changePassword = createAction();
export const passwordChanged = createAction();
export const passwordChangeError = createAction();
export const tokenVerified = createAction();
